"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _FetchClient =
/*#__PURE__*/
function () {
  function _FetchClient(accessToken) {
    _classCallCheck(this, _FetchClient);

    this.accessToken = accessToken;
  }

  _createClass(_FetchClient, [{
    key: "getDefaultConfig",
    value: function getDefaultConfig(method, jsonPayload) {
      var headers = new Headers();
      headers.append('Authorization', "Bearer ".concat(this.accessToken));

      if (method !== 'GET') {
        headers.append('Content-Type', 'application/json');
      }

      var config = {
        method: method,
        headers: headers,
        mode: 'cors',
        cache: 'default',
        retries: 3,
        retryDelay: 500,
        retryOn: [429, 500, 502, 503]
      };

      if (jsonPayload) {
        config.body = JSON.stringify(jsonPayload);
      }

      return config;
    }
  }]);

  return _FetchClient;
}();

exports.default = _FetchClient;